import React, { useEffect } from 'react';
import { Container, Card, CardBody, CardTitle } from 'reactstrap';
import Chart from 'react-apexcharts';

const AIPerformanceChart = ({ lineChart }) => {
  // Map modules from backend response exactly
  const alertTypes = lineChart?.datasets?.map((dataset, index) => {
    const colors = ['#6f42c1', '#dc3545', '#fd7e14', '#20c997', '#1452fd'];
    return {
      name: dataset.module_name,
      module_id: dataset.module_id,
      color: colors[index % colors.length]
    };
  }) || [];

  const chartOptions = {
    chart: {
      type: 'line',
      height: 400,
      background: 'transparent',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    grid: {
      show: true,
      borderColor: '#e0e0e0',
      strokeDashArray: 0,
      position: 'back',
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    stroke: {
      width: 2,
      curve: 'straight'
    },
    markers: {
      size: 6,
      strokeWidth: 2,
      strokeColors: '#fff',
      hover: {
        size: 8
      }
    },
    xaxis: {
      categories: lineChart?.labels || [],
      axisBorder: {
        show: true,
        color: '#e0e0e0'
      },
      axisTicks: {
        show: true,
        color: '#e0e0e0'
      },
      labels: {
        style: {
          colors: '#666',
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#666',
          fontSize: '12px'
        },
        formatter: function (value) {
          return Math.floor(value).toString();
        }
      },
      axisBorder: {
        show: true,
        color: '#e0e0e0'
      }
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      markers: {
        width: 10,
        height: 10,
        radius: 5
      },
      itemMargin: {
        horizontal: 15,
        vertical: 10
      },
      labels: {
        useSeriesColors: true,
        colors: '#666'
      },
      onItemClick: {
        toggleDataSeries: true
      },
      onItemHover: {
        highlightDataSeries: true
      }
    },
    colors: alertTypes.map(alert => alert.color),
    tooltip: {
      enabled: true,
      shared: false,
      intersect: false,
      y: {
        formatter: function (value) {
          return Math.floor(value).toString();
        }
      }
    }
  };

  // Create chart series directly from backend datasets
  const createChartSeries = () => {
    const series = [];
    const backendDatasets = lineChart?.datasets || [];

    // Map each dataset directly to a series
    backendDatasets.forEach((dataset, index) => {
      const colors = ['#6f42c1', '#dc3545', '#fd7e14', '#20c997', '#1452fd'];
      
      series.push({
        name: dataset.module_name,
        data: dataset.data || [],
        color: colors[index % colors.length],
        module_id: dataset.module_id
      });
    });

    return series;
  };

  const chartSeries = createChartSeries();

  useEffect(() => {
    console.log('Line Chart Data:', lineChart);
    console.log('Backend Datasets:', lineChart?.datasets);
    console.log('Generated Series:', chartSeries);
    
    // Debug: Show what modules are found vs expected
    if (lineChart?.datasets) {
      console.log('Available modules from backend:');
      lineChart.datasets.forEach(dataset => {
        console.log(`- ${dataset.module_name}: [${dataset.data.join(', ')}]`);
      });
    }
  }, [lineChart]);

  return (
    <Card className="shadow-sm">
      <CardBody>
        <CardTitle tag="h4" className="mb-3" style={{ color: '#091954', fontWeight: '600' }}>
          Alert Trend
        </CardTitle>
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="line"
          height={400}
        />
        <style jsx>{`
          .apexcharts-legend-series {
            background: white !important;
            border: 1px solid #dee2e6 !important;
            border-radius: 4px !important;
            padding: 6px 10px !important;
            margin: 0 4px 8px !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.12) !important;
            transition: all 0.2s ease !important;
          }
          .apexcharts-legend-series:hover {
            box-shadow: 0 2px 6px rgba(0,0,0,0.16) !important;
            transform: translateY(-1px) !important;
          }
          .apexcharts-legend-marker {
            margin-right: 8px !important;
            border-radius: 50% !important;
          }
          .apexcharts-legend-text {
            color: #666 !important;
            font-weight: 500 !important;
            font-size: 12px !important;
          }
        `}</style>
      </CardBody>
    </Card>
  );
};

export default AIPerformanceChart;